import React, {Component} from "react";
import {connect} from "react-redux";
import {Field, reduxForm} from "redux-form/immutable";
import {submit} from "redux-form";
import ActionButton from "../../ActionButton";
import FormFieldsTable from "../../forms/FormFieldsTable";
import TextInputField from "../../forms/TextInputField";
import DropDownInputField from "../../forms/DropDownInputField";
import {Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {loadCouriers, cancelAssignWarehouseCourier, assignWarehouseCourier} from "../../../actions/ShippingApiActions";
import {getSubmitInfoForCommand, getWarehouseWithId} from "../../../reducers/inventoryReducer";
import {getCouriers} from "../../../reducers/shippingReducer";
import {isSubmitting, submitLabel} from "../../../lib/CommandStatus";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "courier_id");
  errors = validatePresence(errors, values, "account_nr");
  return errors.toJS();
}

class AssignWarehouseCourierForm extends Component {

  componentDidMount() {
    this.props.loadCouriers(this.props.meta);
  }

  render() {
    let {handleSubmit, submit, submitInfo, couriers} = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Courier"
              name="courier_id"
              component={DropDownInputField}
              data={couriers}
              valueKey="id"  
              titleKey="name" 
              />
            <Field 
              label="Account Nr"
              name="account_nr"
              component={TextInputField}
              />
          </FormFieldsTable>
        </div>
        <div className="buttons">
          <ActionButton label={submitLabel(submitInfo, "Submit")} onClick={submit} active={!isSubmitting(submitInfo)} />
          <ActionButton label="Cancel" active={!isSubmitting(submitInfo)} onClick={this.props.cancelAssignWarehouseCourier} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AssignWarehouseCourierForm",
  validate: validateForm
})(AssignWarehouseCourierForm);

const ConnectedForm = connect(
  (state, ownProps) => {
    const warehouse = getWarehouseWithId(state.get("inventory"), ownProps.id);
    return {
      submitInfo: getSubmitInfoForCommand(state.get("shipping"), "AssignWarehouseCourier"),
      couriers: getCouriers(state.get("shipping")),
      initialValues: {
        id: ownProps.id,
        courier_id: warehouse.get("courier_id", ""),
        account_nr: warehouse.get("courier_account_nr", ""),
      }
    }
  },
  {
    cancelAssignWarehouseCourier,
    loadCouriers,
    submit,
    onSubmit: (data) => assignWarehouseCourier(data)
  }
)(ReduxForm);

export default ConnectedForm;